import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { ActionModel } from '../../main/Models';

@Component({
  selector: 'mdr-checklist',
  templateUrl: './t_checklist.component.html',
  styleUrls: ['./checklist.component.less']
})
export class ChecklistComponent implements OnInit {

	@Input('action') action:ActionModel;
	@Input('showTODO') showTODO:boolean = false;

  constructor() { }

  ngOnInit() {
  }

  /*switchTODO()
  {
    if(this.action.jsonDetails.todo==undefined)
      this.action.jsonDetails.todo = [];

    this.showTODO = !this.showTODO;
  }*/
  addTODO()
  {
  	if(this.action.jsonDetails.todo==undefined)
  		this.action.jsonDetails.todo = [];

  	this.action.jsonDetails.todo.push({task:'', done:false, doneDate:null, edit: true});
    this.action.saveIt = true;
  }
  focusTODO(todo, index)
  {
  	todo.edit=true;
  }
  blurTODO(todo, index, $event=null) 
  {
	  if($event && $event.code && $event.code=='Enter') {
      todo.edit=false;
      if(todo.task=='') this.action.jsonDetails.todo.splice(index,1)
      else this.addTODO();
    } else if(!$event || ($event && $event.code && $event.code=='Escape')) {
      if((todo.task=='')) this.action.jsonDetails.todo.splice(index,1);
      else todo.edit=false;
    }
  }

  deleteTODO(todo, index)
  {
    this.action.jsonDetails.todo.splice(index,1); 
    todo.confirming=false;
    this.action.saveIt = true;
  }


  setTodoDate(todo, checked) {
    if(checked) todo.doneDate = new Date();
    this.action.saveIt = true;
  }
  get todoRatio()
  {
    if(this.action.jsonDetails.todo==undefined) return 0;
    let total = this.action.jsonDetails.todo.length;
    let checked = this.action.jsonDetails.todo.filter((task)=>{return task.done}).length;
    let ratio = 100*checked / total;
    return ratio;
  }

}
